
import { PAGES } from "@consts";

export default {
	name: "TheGetTheAppButton",
	computed: {
		isGetTheAppPage() {
			return this.$route.name === PAGES.GET_THE_APP;
		},
		isCrosswordsPage() {
			return this.$store.getters["navigation/isCrosswordsPage"];
		},
		appUrl() {
			if (this.isCrosswordsPage) {
				return "https://crosswordsolver.onelink.me/5xYW/99j75rg0";
			}

			return this.isGetTheAppPage
				? "https://wordfinder.onelink.me/NEup/82f509f9"
				: "https://wordfinder.onelink.me/NEup/18927699";
		},
	},
	methods: {
		onButtonClick() {
			this.$store.dispatch("tracking/trackEvent", {
				eventCategory: "App CTA",
				eventAction: "Click mobile button",
			});
		},
	},
};
